import { User } from "./dashboard-common.model";
import { MemberFirm } from "./masterdata.model";

export interface UserByEmail {
  email: string;
  user: UserDetail;
}
export interface UserDetail extends User{
  homeBuildingId: number;
  homeBuildingName: string;
  title: string;
  shortTitle: string;
  area: string;
  fss: string;
  hasConciergeRights: boolean;
  isNonPeopleProfile: boolean;
  isMemberFirmAccount: boolean;
  memberFirm: MemberFirm;
}
export interface UserNotificationResponse {
  id: number;
  message: string;
  expiryDateUtc: string;
  extraData: string;
  createDate: string;
  data: UserNotificationExtraData;
}
export interface UserNotificationExtraData {
  name: string;
  navigationLinkCategory: string;
  $discriminator?: string;
  teamName: string;
  teamRequestId: string;
  reservationRequestedCount?: number;
  reservationCreatedCount?: number;
  issueCount?: number;
}
export enum UserNotificationType {
  TeamRequestInProgress ='TeamRequestInProgress',
  TeamRequestCompleted ='TeamRequestCompleted'
}
export class InactiveOwner {
  FirstName: string;
  LastName: string;    
}